export const equipmentTypes = [
  'Raw',
  'Straps',
  'Multi-Ply',
  'Single-Ply',
  'Wraps',
  'Unlimited',
];
